import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "阅读功能", href: "#features" },
  { label: "热门作品", href: "#popular" },
  { label: "题材分类", href: "#categories" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg"></i>
          </span>
          <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
            MGB<span className="text-primary-600">漫画网</span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-700 cursor-pointer transition-colors hover:text-primary-600">
            <i className="ri-search-line text-base"></i>
          </span>
          <Link
            to="/reader"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即阅读
          </Link>
        </div>

        <button
          type="button"
          aria-label="菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <Link
              to="/reader"
              onClick={() => setOpen(false)}
              className="mt-1 rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              立即阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}